import { Component, computed, Inject, inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { WireActions, WireApiActions } from '@discover/store/actions/discover.actions';
import { selectCurrentSelectedViewState, selectCurrentViewTopics, selectIsAttachToTopicListLoading, selectSavedViewStates } from '@discover/store/selectors/discover.selectors';
import { Store } from '@ngrx/store';
import { CastService } from '@src/suite/cast/services/cast-service';
import { LanguageSettings } from '@src/suite/common/services/language-settings';
import { LayoutState } from '@src/suite/common/services/layout-state';

@Component({
    selector: 'st-discover-item-attach-to-dialog',
    templateUrl: './discover-item-attach-to-dialog.html',
    styleUrls: ['./discover-item-attach-to-dialog.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-discover-item-attach-to-dialog',
    },
})
export class DiscoverItemAttachToDialogComponent {
    public savedViewDropdownVisible: boolean = true;
    public searchTerm: string = '';
    store = inject(Store);
    selectTopics = computed(() => this.store.selectSignal(selectCurrentViewTopics)());
    selectSavedViewStates = this.store.selectSignal(selectSavedViewStates);
    currentViewState = this.store.selectSignal(selectCurrentSelectedViewState);
    selectIsAttachToTopicListLoading$ = this.store.select(selectIsAttachToTopicListLoading);

    constructor(
        public dialogRef: MatDialogRef<DiscoverItemAttachToDialogComponent>,
        public castService: CastService,
        public layoutState: LayoutState,
        public languageSettings: LanguageSettings,
        @Inject(MAT_DIALOG_DATA) public inputData: StorytellingWireRecord
    ) {
        this.store.dispatch(WireApiActions.loadTopicViewStates());
    }

    public async toggleTabVisibility(savedViewDropdownVisible: boolean) {
        this.savedViewDropdownVisible = savedViewDropdownVisible;
        if (this.savedViewDropdownVisible) {
            // if we are switching from search to saved views, and there is a saved view selected
            // we need to prefetch again
            this.searchTerm = '';
            this.store.dispatch(WireApiActions.reloadTopicsBasedOnCurrentViewState({ viewState: this.selectSavedViewStates()?.views.find(view => view?.guid === this.currentViewState().guid) }));
        } else {
            // clear available records whenever we switch to search view
            // this.castService.availableRecords = new Array<Record>();
        }
    }

    public onSearchHandler(value: string | number) {
        this.store.dispatch(WireApiActions.topicSearchTerm({ searchTerm: value.toString() }));
    }

    public onAttachItem(record: StorytellingTopicRecord) {
        this.store.dispatch(WireApiActions.attachItem({ wire: this.inputData, topic: record }));
    }

    public cancelNew() {
        this.dialogRef.close();
    }

    public trackByGuid(index, node) {
        if (node) {
            return node?.Guid;
        }
    }

    onViewStateGuidChanged(viewState: MatSelectChange) {
        this.store.dispatch(WireActions.setCurrentTopicViewState({ viewState: this.selectSavedViewStates()?.views.find(view => view?.guid === viewState?.value) }));
    }
}
